import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=1f2b0c31&"
import script from "./Icons.vue?vue&type=script&lang=js&"
export * from "./Icons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f2b0c31')) {
      api.createRecord('1f2b0c31', component.options)
    } else {
      api.reload('1f2b0c31', component.options)
    }
    module.hot.accept("./Icons.vue?vue&type=template&id=1f2b0c31&", function () {
      api.rerender('1f2b0c31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/HomeVantage/Summaries/Tabs/Icons.vue"
export default component.exports